"use client";

/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */

import classNames from "classnames";
import { useState, useEffect, useRef } from "react";
import HideIf from "util/HideIf";
import styles from "./slider.module.scss";

function Slider({
  itemStyle = {},
  tileWidth = 160,
  children,
  autoplay = false,
  autoplaySpeed = 7000,
  ulClass = "",
  liClass = "",
  showScrollOnHover = false,
  showArrowOnHover = false,
}: any) {
  const viewModeDivRef = useRef(null);
  const [scrollPos, setScrollPos] = useState(0);
  const [isScrollActive, setIsScrollActive] = useState(false);
  const [autoplayInterval, setAutoplayInterval] = useState();

  const scrollSlider = (pos: any) => {
    try {
      viewModeDivRef?.current?.scrollTo({
        left: pos,
        behavior: "smooth",
      });
    } catch (err) {
      if (viewModeDivRef && viewModeDivRef.current) {
        viewModeDivRef.current.scrollLeft = pos;
      }
    }
  };

  const goLeft = () => {
    if (scrollPos === 0) {
      return;
    }
    scrollSlider(viewModeDivRef?.current?.scrollLeft - tileWidth);
  };

  const goRight = () => {
    scrollSlider(viewModeDivRef?.current?.scrollLeft + tileWidth);
  };

  const getHorizontalMargin = () => {
    if (!viewModeDivRef.current) {
      return { marginLeft: 0, marginRight: 0 };
    }

    const li = viewModeDivRef.current.children[0];
    const liStyle = getComputedStyle(li);
    return {
      marginLeft: parseInt(liStyle.getPropertyValue("margin-left"), 10),
      marginRight: parseInt(liStyle.getPropertyValue("margin-right"), 10),
    };
  };

  const handleSliderScroll = () => {
    setScrollPos(viewModeDivRef?.current?.scrollLeft);
  };

  /*
  Right button is disabled when scrollLeft is at it's max position.
  scroll max position = total width of tiles - visible area
  total width of tiles = (width of tile + marginLeft + marginRight) * no of tiles
  */
  const isRightDisabled = () => {
    const { marginLeft, marginRight } = getHorizontalMargin();
    const scrollMaxPos = (tileWidth + marginLeft + marginRight) * children.length - viewModeDivRef?.current?.clientWidth;
    return scrollMaxPos === viewModeDivRef?.current?.scrollLeft || scrollMaxPos < 0;
  };

  const autoplayFunc = () => {
    if (isRightDisabled()) {
      scrollSlider(0);
    } else {
      goRight();
    }
  };

  const createInterval = () => {
    if (autoplay) {
      const interval = setInterval(autoplayFunc, autoplaySpeed);

      setAutoplayInterval(interval);
    }
  };

  const destroyInterval = () => {
    clearInterval(autoplayInterval);
  };

  const leftDisabled = scrollPos === 0;
  const rightDisabled = isRightDisabled();

  function handleSliderTouchStart() {
    setIsScrollActive(true);
  }

  function handleSliderTouchEnd() {
    setIsScrollActive(false);
  }

  useEffect(() => {
    createInterval();
    if (viewModeDivRef && viewModeDivRef.current) {
      viewModeDivRef.current.addEventListener("touchstart", handleSliderTouchStart, { passive: true });
      viewModeDivRef.current.addEventListener("touchend", handleSliderTouchEnd, { passive: true });
    }

    return () => {
      destroyInterval();
      if (viewModeDivRef && viewModeDivRef.current) {
        viewModeDivRef.current.removeEventListener("touchstart", handleSliderTouchStart);
        viewModeDivRef.current.removeEventListener("touchend", handleSliderTouchEnd);
      }
    };
  }, []);

  if (children.length === 0) {
    return null;
  }

  return (
    <div className={styles.slider_wrapper}>

      <div
        className={classNames(styles.container, {
          [styles.scroll_hover]: showScrollOnHover,
          [styles.scroll_active]: showScrollOnHover && isScrollActive,
        })}
        onMouseOver={destroyInterval}
        onFocus={destroyInterval}
        onMouseOut={createInterval}
        onBlur={createInterval}
      >

        <ul
          ref={viewModeDivRef}
          className={`${styles.slider} ${ulClass}`}
          onScroll={handleSliderScroll}
        >
          {children.map((child: any, index: any) => (
            <li key={index} className={`${styles.slide} ${liClass}`} style={{ width: tileWidth, minWidth: tileWidth, ...itemStyle }}>{child}</li>
          ))}
        </ul>

        <HideIf show={!(leftDisabled && rightDisabled)}>

          <button
            type="submit"
            disabled={leftDisabled}
            className={`${styles.goLeft} ${styles.buttonNav}
           ${showArrowOnHover ? styles.show_arrow_on_hover : ""}`}
            onClick={goLeft}
          >

            <i className={`fa fa-chevron-left ${styles.left_arrow}`} />
          </button>

          <button
            type="submit"
            disabled={rightDisabled}
            className={`${styles.goRight} ${styles.buttonNav}
            ${showArrowOnHover ? styles.show_arrow_on_hover : ""}`}
            onClick={goRight}
          >

            <i className={`fa fa-chevron-right ${styles.right_arrow}`} />
          </button>
        </HideIf>
      </div>
    </div>
  );
}

export default Slider;
